function initializeModalAndAccordion() {
    // Check if modal toggle buttons exist before adding event listeners
    const modalToggle = document.querySelector('[data-toggle="modal"]');
    const modalDismiss = document.querySelector('[data-dismiss="modal"]');
    const modal = document.getElementById('size-guide');

    if (modalToggle && modalDismiss && modal) {
        modalToggle.addEventListener('click', function (event) {
            event.preventDefault();
            toggleSizeModel();
        });

        modalDismiss.addEventListener('click', function (event) {
            event.preventDefault();
            toggleSizeModel();
        });

        function toggleSizeModel() {
            if (modal.style.display === 'block') {
                modal.style.display = 'none';
                document.body.style.overflow = 'auto';
            } else {
                updateTable();
                modal.style.display = 'block';
                document.body.style.overflow = 'hidden';
            }
        }

        modal.addEventListener('click', function (event) {
            if (event.target === this) {
                this.style.display = 'none';
                document.body.style.overflow = 'auto';
            }
        });
    }

    // Get size guide and unit elements, add conditional checks
    const sizeGuideTypeSelect = document.getElementById('sizeGuideType');
    const unitButtons = document.querySelectorAll('.unit-toggle');

    if (sizeGuideTypeSelect && unitButtons.length > 0) {
        function updateTable() {
            const selectedType = sizeGuideTypeSelect.value;
            const selectedUnitButton = document.querySelector('.unit-toggle.btn-selected');
            if (!selectedUnitButton) return;

            const selectedUnit = selectedUnitButton.dataset.unit;
            const allTables = document.querySelectorAll('.size-guide-content');

            allTables.forEach(content => content.style.display = 'none');

            const tableId = `size-guide-${selectedType}`;
            const selectedTableContent = document.getElementById(tableId);

            if (selectedTableContent) {
                selectedTableContent.style.display = 'block';
                const unitTables = selectedTableContent.querySelectorAll('table');
                unitTables.forEach(table => table.style.display = 'none');

                const unitTable = selectedTableContent.querySelectorAll(`[data-table="${selectedType}-${selectedUnit}"]`);
                if (unitTable) {
                    unitTable.forEach(table => table.style.display = 'table');
                }
            }
        }

        sizeGuideTypeSelect.addEventListener('change', updateTable);

        unitButtons.forEach(button => {
            button.addEventListener('click', function () {
                unitButtons.forEach(btn => btn.classList.remove('btn-selected'));
                this.classList.add('btn-selected');
                updateTable();
            });
        });

        unitButtons[0].classList.add('btn-selected');
        updateTable();
    }

    // Check if accordion headers exist before adding event listeners
    const accordionHeaders = document.querySelectorAll(".card-header__title");
    if (accordionHeaders.length > 0) {
        accordionHeaders.forEach(header => {
            header.addEventListener("click", function (e) {
                e.preventDefault();
                const targetId = header.getAttribute("href").substring(1);
                const content = document.getElementById(targetId);
                const toggleSymbol = header.querySelector(".accordion-toggle-symbol");

                const isCollapsed = content.classList.contains("show");
                if (isCollapsed) {
                    content.classList.remove("show");
                    header.setAttribute("aria-expanded", "false");
                    header.classList.add("collapsed");
                    toggleSymbol.textContent = "+";
                } else {
                    document.querySelectorAll(".collapse.show").forEach(collapse => {
                        collapse.classList.remove("show");
                        collapse.previousElementSibling.querySelector(".card-header__title").setAttribute("aria-expanded", "false");
                        collapse.previousElementSibling.querySelector(".card-header__title").classList.add("collapsed");
                        collapse.previousElementSibling.querySelector(".accordion-toggle-symbol").textContent = "+";
                    });

                    content.classList.add("show");
                    header.setAttribute("aria-expanded", "true");
                    header.classList.remove("collapsed");
                    toggleSymbol.textContent = "−";
                }
            });
        });
    }
}

// Run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initializeModalAndAccordion);

// Run on section:load
document.addEventListener('section:load', initializeModalAndAccordion);
